/**
 * PlyxMovingTagline — letter-by-letter horizontal travel of the brand
 * promise "where moments become movements" across the feed/gallery
 * surface. Each letter is laid out individually so we can stagger
 * its animation: a continuous left-to-right marquee with a subtle
 * per-letter wave (translateY oscillation) so the words feel alive,
 * not just sliding.
 *
 * Variants:
 *   • `variant="feed"`     — top-of-feed overlay, full width
 *   • `variant="gallery"`  — slimmer band above the profile grid
 *
 * Honours `prefers-reduced-motion` (the marquee freezes and the band
 * collapses to a static gradient line).
 */
import React from "react";

const TEXT = "where moments become movements";

const PlyxMovingTagline = ({ variant = "feed", className = "" }) => {
  const heightClass = variant === "feed" ? "h-7" : "h-6";
  // Duplicate the phrase so the marquee track is wider than the
  // viewport — guarantees seamless looping at any screen size.
  const phrase = `${TEXT} · ${TEXT} · ${TEXT} · `;
  const letters = phrase.split("");

  return (
    <div
      data-testid={`plyx-moving-tagline-${variant}`}
      className={`plyx-moving-tagline relative overflow-hidden ${heightClass} ${className}`}
      aria-label={TEXT}
    >
      {/* Soft edge fade so the marquee feels embedded, not abrupt. */}
      <div className="plyx-moving-tagline-mask absolute inset-0 pointer-events-none" />
      <div className="plyx-moving-tagline-track flex items-center whitespace-nowrap">
        {letters.map((ch, i) => (
          <span
            key={i}
            className={ch === " " ? "plyx-moving-tagline-space" : "plyx-moving-tagline-letter"}
            style={{ animationDelay: `${(i % 40) * 70}ms` }}
            aria-hidden="true"
          >
            {ch === " " ? "\u00A0" : ch}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PlyxMovingTagline;
